/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import { filterBy } from '@linc-technologies/linced-common/utils/arrays';

export default class EldestYoungestController extends Controller {
  queryParams = ['filter'];

  @computed('filter')
  get title() {
    return `${this.filter === 'eldest' ? 'Eldest' : 'Youngest'} in the Family`;
  }

  @computed('filter', 'model.[]')
  get filteredPeople() {
    let field = 'isYoungest';
    if (this.filter === 'eldest') {
      field = 'isEldest';
    }
    return filterBy(this.model, `learner.${field}`);
  }
}
